import { Column, Row } from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Card from "../../components/Card/Card";
import http from "../../http-common";
import { PieChart, StackedBarChart } from "@carbon/charts-react";

const pieChartOptions = {
  title: "",
  resizable: true,
  legend: {
    alignment: "center",
  },
  pie: {
    alignment: "center",
  },
  height: "200px",
};

const pieChartOptions1 = {
  title: "",
  resizable: true,
  legend: {
    alignment: "center",
  },
  pie: {
    alignment: "center",
  },
  height: "400px",
};

const barChartOptions = {
  title: "",
  axes: {
    left: { mapsTo: "value" },
    bottom: { mapsTo: "group", scaleType: "labels" },
  },
  height: "400px",
};

const options = {
  title: "",
  axes: {
    left: {
      mapsTo: "value",
      stacked: true,
    },
    bottom: {
      mapsTo: "key",
      scaleType: "labels",
    },
  },
  height: "400px",
};
const DashboardPage = () => {
  const [stats, setStats] = useState({});
  const [byGender, setByGender] = useState([]);
  const [byExistingBusiness, setByExistingBusiness] = useState([]);
  const [byProvince, setByProvince] = useState([]);
  const [businessPlansByGender, setBusinessPlansByGender] = useState([]);
  const [businessPlansByExistingBusiness, setBusinessPlansByExistingBusiness] =
    useState([]);
  const [byProvinceSubmitedCandidature, setByProvinceSubmitedCandidature] =
    useState([]);

  const [businessPlansByProvince, setBusinessPlansByProvince] = useState([]);

  const getStats = async () => {
    try {
      const response = await http.get("/applications/stats");
      setStats(response.data);
      setByGender(response.data.byGender);
      setByProvince(response.data.byProvince);
      setByExistingBusiness(response.data.byExistingBusiness);
      setBusinessPlansByGender(response.data.businessPlansByGender);
      setBusinessPlansByExistingBusiness(
        response.data.businessPlansByExistingBusiness
      );
      setByProvinceSubmitedCandidature(
        response.data.byProvinceSubmitedCandidature
      );
      setBusinessPlansByProvince(response.data.businessPlansByProvince);
    } catch (error) {
      toast.error("Erro ao carregar dados estatísticos");
    }
  };

  useEffect(() => {
    getStats();
  }, []);

  return (
    <>
      <h3>Dashboard</h3>
      <div className="dashboard">
        <Row>
          <Column xsm={12} sm={12} lg={8} xlg={8}>
            <Card title="Candidaturas">
              <table className="table table-borderless text-center">
                <tr>
                  <td>
                    <p>Total</p>
                    <h1>{stats.total}</h1>
                  </td>
                  <td>
                    <p>Submetidas</p>
                    <h1>{stats.totalSubmittedApplications}</h1>
                  </td>
                  <td>
                    <p>Elegíveis</p>
                    <h1>{stats.totalEligibleCompetitors}</h1>
                  </td>
                  <td>
                    <p>Apuradas</p>
                    <h1>{stats.totalQualifiedCompetitors}</h1>
                  </td>
                </tr>
              </table>
            </Card>
          </Column>

          <Column xsm={12} sm={12} lg={4} xlg={4}>
            <Card title="Planos de Negócios">
              <table className="table table-borderless text-center">
                <tr>
                  <td>
                    <p>Registados</p>
                    <h1>{stats.totalBusinessPlans}</h1>
                  </td>
                  <td>
                    <p>Submetidos</p>
                    <h1>{stats.totalSubmittedBusinessPlans}</h1>
                  </td>
                </tr>
              </table>
            </Card>
          </Column>
        </Row>
        <Row className="mt-2">
          <Column xsm={12} sm={12} lg={3} xlg={3}>
            <Card title="Candidaturas por Género">
              <PieChart data={byGender} options={pieChartOptions}></PieChart>
            </Card>
          </Column>
          <Column xsm={12} sm={12} lg={3} xlg={3}>
            <Card title="Candidaturas: Negócio vs Ideia">
              <PieChart
                data={byExistingBusiness}
                options={pieChartOptions}
              ></PieChart>
            </Card>
          </Column>
          <Column xsm={12} sm={12} lg={3} xlg={3}>
            <Card title="Planos de Negócio por Género">
              <PieChart
                data={businessPlansByGender}
                options={pieChartOptions}
              ></PieChart>
            </Card>
          </Column>
          <Column xsm={12} sm={12} lg={3} xlg={3}>
            <Card title="Planos de Negócio: Negócio vs Ideia">
              <PieChart
                data={businessPlansByExistingBusiness}
                options={pieChartOptions}
              ></PieChart>
            </Card>
          </Column>
        </Row>
        <Row className="mt-2">
          <Column>
            <Card title="Candidaturas por Província">
              <StackedBarChart
                data={byProvince}
                options={options}
              ></StackedBarChart>
            </Card>
          </Column>
        </Row>
        <Row className="mt-2">
          <Column>
            <Card title="Planos de Negócio por Província">
              <StackedBarChart
                data={businessPlansByProvince}
                options={options}
              ></StackedBarChart>
            </Card>
          </Column>
        </Row>
      </div>
    </>
  );
};

export default DashboardPage;
